import type { MutableRefObject } from 'react'
import { useEffect, useState } from 'react'

interface WindowSizeState {
  height?: number
  width?: number
}

export function useWindowSize(
  ref: MutableRefObject<HTMLElement | null>,
): WindowSizeState {
  const [windowSize, setWindowSize] = useState<WindowSizeState>({
    height: undefined,
    width: undefined,
  })

  useEffect(() => {
    let timeoutId: number

    const handleResize = () => {
      clearTimeout(timeoutId)

      timeoutId = window.setTimeout(() => {
        if (ref.current) {
          setWindowSize({
            height: window.innerHeight,
            width: window.innerWidth,
          })
        }
      }, 150)
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [ref])

  return windowSize
}
